import React from "react";
import { InventoryControlPanel } from "./InventoryControlPanel";
import { OpenStockTable } from "./OpenStockTable";

export const OpenStockView = ({
  search,
  setSearch,
  filters,
  setFilters,
  dynamicSettings,
  activeTab,
  openingStocks = [],
  inventory = [],
  handleNewOpenStock,
  setViewItem,
  handleEditOpenStock,
  parties,
  deleteItem
}) => {
  const allOpenStock = openingStocks;

  if (inventory.length === 0 && openingStocks.length === 0 && activeTab) {
     // Just a fallback to let me inspect the props visually on the user's screen if needed, though they already sent a screenshot
  }

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <InventoryControlPanel
        activeTab={activeTab}
        search={search}
        setSearch={setSearch}
        filters={filters}
        setFilters={setFilters}
        dynamicSettings={dynamicSettings}
        onAddItemClick={handleNewOpenStock}
        buttonLabel="Record Open Stock"
        parties={parties}
        showStatusFilter={false}
        showVendorFilter={true}
        showCustomerFilter={false}
      />
      <OpenStockTable
        items={allOpenStock}
        onView={setViewItem}
        onEdit={handleEditOpenStock}
        onDelete={deleteItem}
      />
    </div>
  );
};

